import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { Banco } from '@/types/depo20';

interface ApiResponse<T> {
  value: T;
}

export const getBancos = async (): Promise<Banco[]> => {
  try {
    const res = await apiClient.post<ApiResponse<Banco[]>>(
      Endpoints.LiquidacionesComboBancos,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
